import {
    SET_LANGUAGE,
} from '../actions/type'

const initialState = localStorage.getItem('i18nextLng')

const language = (state = initialState, action) => {
    switch (action.type) {
        case SET_LANGUAGE: {
            const payload = action.payload;
            return payload;
        }
        default:
            return state
    }
}

export default language